import React from 'react';
import styles from './styles.module.scss';
import Text from 'components/typografy/text';
import classNames from 'classnames';
import {FaCheck} from 'react-icons/fa6';
import {IVendor} from 'types/payment';

const Item: React.FC<{
  vendor: IVendor;
  amount: any;
  fee: any;
  control: any;
  field: any;
  checked: boolean;
}> = ({vendor, amount, fee, field, checked}) => {
  return (
    <label className={classNames(styles.wrapper, {[styles.active]: checked})}>
      <div className={styles.checkbox}>
        <FaCheck />
      </div>
      <input type="radio" className={styles.hidden} {...field} value={amount} />
      <Text variant={'medium'} nativeClassname={styles.title}>
        <>${amount}</>
      </Text>
      <div className={classNames(styles.image, styles[vendor.name])}>
        <img src={vendor.image} alt={vendor.displayName} />
      </div>
      <div className={styles.hr} />
    </label>
  );
};

export default Item;
